// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__13EPo","notes":"Notes_notes__3Wk-2","note":"Notes_note__2P-RS","markdown":"Notes_markdown__3CGIp"};